import { render, staticRenderFns } from "./GenTables.vue?vue&type=template&id=12479519&scoped=true&"
import script from "./GenTables.vue?vue&type=script&lang=js&"
export * from "./GenTables.vue?vue&type=script&lang=js&"
import style0 from "./GenTables.vue?vue&type=style&index=0&id=12479519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12479519",
  null
  
)

export default component.exports